import BCKSPDFPreview from 'app/BCKSPage/PDFPreview'

import type { NextPageContext } from 'next'

export async function getServerSideProps(ctx: NextPageContext) {
  return {
    props: {
      url: ctx.query.url,
      title: ctx.query.title,
    },
  }
}

const BCKSPDFPreviewPage = ({ url, title }) => {
  return <BCKSPDFPreview url={url} title={title} />
}

// eslint-disable-next-line react/display-name
BCKSPDFPreviewPage.Layout = ({ children }) => children

export default BCKSPDFPreviewPage
